import type { MasterFieldDef } from '../constants/masters';

const ASSET_FIELD_KEYS = new Set([
  'image', 'imageUrl', 'icon', 'iconUrl', 'iconImage', 'logo', 'favicon', 'avatar',
  'banner', 'thumbnail', 'thumbnailImage', 'photo', 'fileUrl', 'flagUrl', 'gallery',
  'poster', 'coverImage', 'cover',
]);

const ASSET_LABEL_PATTERN = /\b(image|logo|favicon|avatar|icon|banner|thumbnail|photo|poster|cover|gallery)\b/i;

export function resolveAssetUrl(value: string): string {
  if (!value) return '';
  if (value.startsWith('http://') || value.startsWith('https://') || value.startsWith('data:')) {
    return value;
  }
  const apiBase = (import.meta.env.VITE_API_URL || '/api/v1').replace(/\/api\/v\d+\/?$/, '');
  const path = value.startsWith('/') ? value : `/${value}`;
  if (path.startsWith('/uploads/')) {
    return `${apiBase}${path}`;
  }
  return path;
}

export function isAssetUrlField(field: Pick<MasterFieldDef, 'key' | 'label' | 'type'>): boolean {
  if (field.type === 'url' || field.type === 'image') return true;
  if (ASSET_FIELD_KEYS.has(field.key)) return true;
  return ASSET_LABEL_PATTERN.test(field.label) && field.type === 'text';
}
